import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const SkeletonFeaturedUpdate: React.FC = () => {
  return (
    <div className="update_top_wrap placeholder-glow">

      {/* Left content */}
      <div className="update_content">
        {/* Update type */}
        <span
          className="placeholder col-4 mb-2 d-inline-block"
          style={{ height: "16px", borderRadius: "4px" }}
        ></span>

        {/* Title */}
        <div className="mb-2">
          <span
            className="placeholder col-9 d-block mb-2"
            style={{ height: "22px", borderRadius: "6px" }}
          ></span>
          <span
            className="placeholder col-7 d-block"
            style={{ height: "22px", borderRadius: "6px" }}
          ></span>
        </div>

        {/* Date */}
        <div className="update_footer">
          <span
            className="placeholder col-5"
            style={{ height: "14px", borderRadius: "4px" }}
          ></span>
        </div>
      </div>

      {/* Right image */}
      <div className="top_static_img list_page">
        <span
          className="placeholder d-block rounded"
          style={{ width: "643px", height: "362px" }}
        ></span>
      </div>
    </div>
  );
};

export default SkeletonFeaturedUpdate;
